import { useQuery } from '@tanstack/react-query'

import type { Store } from '@/api/@types'
import type { Methods } from '@/api/v1/stores'
import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { QueryConfig } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { storeKeyFactory } from './key'

type StoresResponse = Methods['get']['resBody']

const getStores = (storeCode: string | null): Promise<StoresResponse> => {
  if (isDenebEnabled && storeCode) {
    return aspidaClient.v1.employee.proxy_stores.$get().then((res) => ({
      stores: (res.stores ?? []).map(
        (s) =>
          ({
            storeCode: s.storeCode,
            storeName: s.storeName,
            isDepositStore: false,
            zipCode: s.zipCode ?? '',
            address1: s.address1 ?? '',
            address2: s.address2 ?? '',
            email: '',
            tel: s.tel ?? '',
            importOrder: null,
            shippingLabelName: s.storeName,
          } satisfies Store)
      ),
    }))
  }
  return aspidaClient.v1.stores.$get()
}

export type UseStoresOptions = {
  config?: QueryConfig<typeof getStores>
}

export const useStores = ({ config }: UseStoresOptions) => {
  const { storeCode } = useProxyStore()

  const queryConfig: QueryConfig<typeof getStores> = {
    ...config,
    queryKey: storeKeyFactory.stores(),
    queryFn: () => getStores(storeCode),
  }
  return useQuery(queryConfig)
}
